//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    fill: {
      type: String,
      default: "#999999",
    },
    width: {
      type: String,
      default: "15",
    },
    height: {
      type: String,
      default: "16",
    },
  },
};
